import { render, staticRenderFns } from "./MaintenanceDashboard.vue?vue&type=template&id=704bd248&scoped=true&"
import script from "./MaintenanceDashboard.vue?vue&type=script&lang=js&"
export * from "./MaintenanceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceDashboard.vue?vue&type=style&index=0&id=704bd248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704bd248",
  null
  
)

export default component.exports